import { useEffect } from 'react';

const JS_PREFIX = 'JS_SRC=';

export const useJsScript = (markdown: string) => {
  // markdownを改行で分割し、JS_PREFIXを含む行を抽出
  const jsSrcs = markdown
    .split('\n')
    .filter((line) => line.startsWith(JS_PREFIX))
    .map((line) => line.split(JS_PREFIX)[1]);
  const extractedMarkdown = markdown
    .split('\n')
    .filter((line) => !line.startsWith(JS_PREFIX))
    .join('\n');

  useEffect(() => {
    jsSrcs.forEach((src) => {
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      document.body.appendChild(script);
    });

    return () => {
      jsSrcs.forEach((src) => {
        const script = document.querySelector(`script[src="${src}"]`);
        if (script) {
          document.body.removeChild(script);
        }
      });
    };
  }, [jsSrcs]);

  return { extracted: extractedMarkdown };
};
